import {FC, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link} from "react-router-dom";

import clsx from "clsx";

import {reducerSidebar} from "../../../redux/reducer/user/reducers/reducerUser";
import {AppDispatch} from "../../../redux/reducer/store";

import SidebarLink from "../../custom/sidebarLink/sidebarLink";

import {ReactComponent as ReportsIcon} from "../../../assets/icons/reports-icon.svg";
import {ReactComponent as UnloadingsIcon} from "../../../assets/icons/unloading.svg";
import {ReactComponent as TunderIcon} from "../../../assets/icons/tunder-icon.svg";
import {ReactComponent as ChevronIcon} from "../../../assets/icons/chevron.svg";
import {ReactComponent as ListIcon} from "../../../assets/icons/list-icon.svg";
import {ReactComponent as LockIcon} from "../../../assets/icons/Lock.svg";
import {ReactComponent as ProjectsIcon} from "../../../assets/icons/projects.svg";
import {ReactComponent as VacancyIcon} from "../../../assets/icons/vacancy.svg";
import {ReactComponent as VisitGraphIcon} from "../../../assets/icons/visit-graph-icon.svg";
import {IUserOptions} from "../../../types/interfaces";

interface ISidebarOptions {
    isOpenUnloadings: boolean;
    isOpenSidebar: boolean;
}

const AdminSidebarSection: FC<ISidebarOptions> = ({
                                                      isOpenUnloadings,
                                                      isOpenSidebar,
                                                  }) => {
    const dispatch = useDispatch<AppDispatch>();

    const pathname = window.location.pathname;
    const {claims} = useSelector((state: IUserOptions) => state.user.user.data);

    const [additionalLinks, setAdditionalLinks] = useState<
        { to: string; text: string }[]
    >([]);

    const handleOpenUnloadings = (event: React.MouseEvent) => {
        event.preventDefault();
        localStorage.setItem("isOpenUnloadings", JSON.stringify(!isOpenUnloadings));
        dispatch(
            reducerSidebar({
                               isOpenSidebar: isOpenSidebar,
                               isOpenUnloadings: !isOpenUnloadings,
                           })
        );
    };

    useEffect(() => {
        if (
            claims?.length > 0 &&
            (claims.includes("admin") || claims.includes("orders:excel"))
        ) {
            setAdditionalLinks((prev) => [
                ...prev,
                {to: "/unloadings/excel", text: "Excel"},
            ]);
        }

        if (
            claims?.length > 0 &&
            (claims.includes("admin") || claims.includes("orders:zip"))
        ) {
            setAdditionalLinks((prev) => [
                ...prev,
                {to: "/unloadings/zip", text: "Zip"},
            ]);
        }

        if (
            claims?.length > 0 &&
            (claims.includes("admin") || claims.includes("orders:payrolls"))
        ) {
            setAdditionalLinks((prev) => [
                ...prev,
                {to: "/unloadings/tables", text: "Табели"},
            ]);
        }

        if (
            claims?.length > 0 &&
            (claims.includes("admin") || claims.includes("orders:cron"))
        ) {
            setAdditionalLinks((prev) => [
                ...prev,
                {to: "/unloadings/cron", text: "Cron"},
            ]);
        }

        if (
            claims?.length > 0 &&
            (claims.includes("admin") ||
             (claims.includes("orders:import") && claims.includes("orders:import")))
        ) {
            setAdditionalLinks((prev) => [
                ...prev,
                {to: "/unloadings/template", text: "Загрузка шаблонов"},
            ]);
        }
    }, [claims]);

    return (
        <>
            <div className="menu__item">
                <div className="buttons">
                    {/* {(
                     <SidebarLink
                     icon={<VacancyIcon className='active__sidebar_icon' />}
                     to={'/charts'}
                     content='Аналитика'
                     />
                     )} */}
                    {claims &&
                     claims?.length > 0 &&
                     (claims.includes("admin") ||
                      claims.includes("reports:view") ||
                      claims.includes("reports:expired:view")) && (
                         <SidebarLink
                             icon={
                                 <ReportsIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             content="Отчеты"
                             to="/reports"
                         />
                     )}

                    {claims &&
                     claims?.length > 0 &&
                     (claims.includes("admin") ||
                      claims.includes("orders:excel") ||
                      claims.includes("orders:zip") ||
                      claims.includes("orders:cron") ||
                      claims.includes("orders:payrolls")) && (
                         <SidebarLink
                             chevron={
                                 <ChevronIcon
                                     className={clsx(
                                         "chevron__icon",
                     isOpenUnloadings && "active__chevron_icon",
                                         "active__sidebar_icon"
                                     )}
                                     onClick={handleOpenUnloadings}
                                 />
                             }
                             icon={
                                 <UnloadingsIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             to={
                                 claims.includes("admin") || claims.includes("orders:excel")
                                 ? "/unloadings/excel"
                                 : additionalLinks[0]?.to
                             }
                             content="Выгрузки"
                         />
                     )}
                    <div className={clsx(
                            "additional__links_block",
                            isOpenUnloadings && "active__additional_links"
                        )}
                    >
                        {isOpenSidebar &&
                         additionalLinks.map((link) => (
                             <span
                                 className={clsx(
                                     "additional__link",
                         isOpenUnloadings && "active__additional_link"
                                 )}
                                 key={link.to}
                             >
                  <Link
                      className={clsx(
                          "link",
                         pathname.includes(link.to) && "underline"
                      )}
                      to={link.to}
                  >
                    {link.text}
                  </Link>
                </span>
                         ))}
                    </div>

                    {claims &&
                     claims?.length > 0 &&
                     (claims.includes("admin") || claims.includes("tander:view")) && (
                         <SidebarLink
                             icon={
                                 <TunderIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             to="/tunder/shops"
                             content="Тандер"
                         />
                     )}

                    {claims &&
                     claims?.length > 0 &&
                     (claims.includes("admin") ||
                      claims.includes("easy-merch:view")) && (
                         <SidebarLink
                             icon={
                                 <ListIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             to="/easymerch/outlets"
                             content="Easy Merch"
                         />
                     )}

                    {claims &&
                     claims?.length > 0 &&
                     (claims.includes("admin") ||
                      claims.includes("customers:list") ||
                      claims.includes("role:claim:change") ||
                      claims.includes("claim:employee:list")) && (
                         <SidebarLink
                             icon={
                                 <LockIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             to={
                                 claims.includes("admin") ||
                                 claims.includes("role:claim:change")
                                 ? "/accessRights/roles"
                                 : claims.includes("customers:list")
                                   ? "/accessRights/customers"
                                   : claims.includes("claim:employee:list")
                                     ? "/accessRights/users"
                                     : ""
                             }
                             content="Права доступа"
                         />
                     )}

                    {claims &&
                     claims?.length > 0 &&
                     (claims.includes("admin") || claims.includes("projects:list")) && (
                         <SidebarLink
                             icon={
                                 <ProjectsIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             to="/projects"
                             content="Проекты"
                         />
                     )}

                    {claims?.length > 0 &&
                     (claims.includes("admin") ||
                      claims.includes("recruiting:vacancy:view") ||
                      claims.includes("recruiting:applicationform:view")) && (
                         <SidebarLink
                             icon={
                                 <VacancyIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             to={
                                 claims.includes("admin") ||
                                 claims.includes("recruiting:vacancy:view")
                                 ? "/recruiting/vacancy"
                                 : claims.includes("recruiting:applicationform:view")
                                   ? "/recruiting/applicationform"
                                   : ""
                             }
                             content="Набор персонала"
                         />
                     )}

                    {claims?.length > 0 &&
                     (claims.includes("admin") || claims.includes("schedule:list")) && (
                         <SidebarLink
                             icon={
                                 <VisitGraphIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             to="/visit-schedule"
                             content="График"
                         />
                     )}

                    {/*{claims?.length > 0 && (claims.includes('admin') || claims.includes('claim:employee:list')) && (
                     <SidebarLink
                     icon={<EmployeesIcon className='active__sidebar_icon' />}
                     to={'/employees'}
                     content='Сотрудники'
                     />
                     )} */}
                    {claims?.length > 0 &&
                     (claims.includes("admin") || claims.includes("pos:map:view")) && (
                         <SidebarLink
                             icon={
                                 <ReportsIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             content="Карта обслуживания"
                             to="/map"
                         />
                     )}
                    {claims?.length > 0 &&
                     (claims.includes("admin") ||
                      claims.includes("contracts:budget:list")) && (
                         <SidebarLink
                             icon={
                                 <ListIcon className="default__sidebar_icon active__sidebar_icon"/>
                             }
                             content="Контракты"
                             to="/contracts"
                         />
                     )}
                    {/*{claims?.length > 0 && (claims.includes('admin') || claims.includes('claim:employee:list')) && (
                     <SidebarLink
                     icon={<EmployeesIcon className='active__sidebar_icon' />}
                     to={'/employees'}
                     content='Сотрудники'
                     />
                     )} */}
                    {claims?.length > 0 &&
                     (claims.includes("analytics:consolidatedbudget:view")) && (
                        <SidebarLink
                            icon={
                                <ListIcon className="default__sidebar_icon active__sidebar_icon"/>
                            }
                            content="Сводный бюджет"
                            to="/consolidatedbudget"
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default AdminSidebarSection;
